<template>
  <div id="app" class="wrap">
    <OneDayHeader />
    <router-view />
    <OneDayFooter />

    <!-- quick_menu -->
    <ul class="quick_menu mb-0">
      <li class="m1"><a href="tel:02-522-2828" class="btn">전화</a></li>
      <li class="m2"><a href="https://pf.kakao.com/_KPMRxd" target="_blank" class="btn">카톡</a></li>
      <li class="m3"><a href="https://booking.naver.com/booking/13/bizes/250352?area=ple"
                        target="_blank" class="btn">네이버예약</a></li>
      <li class="m4">
        <router-link :to="{name:'introLocation'}" class="btn">진료안내</router-link>
      </li>
      <li class="m5">
        <router-link :to="{name:'introLocation'}" class="btn">오시는길</router-link>
      </li>
    </ul>
    <!-- e : quick_menu -->
  </div>
</template>

<script>
import OneDayHeader from './components/OneDayHeader.vue';
import OneDayFooter from './components/OneDayFooter.vue';

export default {
  components: { OneDayHeader, OneDayFooter },
  data() {
    return {
    };
  },
  mounted() {

  },
  methods: {

  },
};
</script>

<style lang="scss">
  a {
    &:hover {
      text-decoration: none;
    }
  }

  ul {
    margin-bottom: 0;
  }

  /* base */
  body, button, dd, dl, dt, fieldset, form, h1, h2, h3, h4, h5, h6, input, legend, li, ol, p, select, table, td, textarea, th, ul {
    margin: 0;
    padding: 0;
  }

  article, aside, details, figcaption, figure, footer, header, hgroup, menu, nav, section {
    display: block;
  }

  ol, ul, li {
    list-style: none;
  }

  blockquote, q {
    quotes: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  input[type="text"], input[type="password"], input[type="email"], input[type="search"], input[type="image"], input[type="tel"], textarea, button, select {
    -webkit-appearance: none;
    -webkit-border-radius: 0;
    border-radius: 0;
    background: none;
  }

  input:focus, textarea:focus {
    outline-style: none;
  }

  input {
    -webkit-appearance: none;
    -webkit-border-radius: 0;
  }

  img {
    max-width: 100%;
    height: auto;
    vertical-align: middle;
    border: 0;
  }

  a {
    text-decoration: none;
  }

  body, button, h1, h2, h3, h4, h5, input, select, table, textarea {
    font-family: 'Noto Sans KR', AppleSDGothicNeo-Regular, 'Malgun Gothic', '맑은 고딕', dotum, '돋움', sans-serif;
    color: #333;
  }

  /* placeholder */
  input::-webkit-input-placeholder {
    color: #0a2438;
  }

  input::-moz-input-placeholder {
    color: #0a2438;
  }

  input::-moz-placeholder {
    color: #0a2438;
  }

  input::-ms-input-placeholder {
    color: #0a2438
  }

  textarea::-webkit-input-placeholder {
    color: #0a2438;
  }

  textarea::-moz-input-placeholder {
    color: #0a2438;
  }

  textarea::-moz-placeholder {
    color: #0a2438;
  }

  textarea::-ms-input-placeholder {
    color: #0a2438
  }

  .v--modal-overlay {
    background: transparent;
  }

</style>
